module.exports = __webpack_public_path__ + "img/serviceServicePack.71b63461.png";